import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "inventoryinstorepickup-module"
    }}>{`InventoryInStorePickup module`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`InventoryInStorePickupSales`}</inlineCode>{` module provides business logic for In-Store Pickup functionality related to Sales operations.`}</p>
    <p>{`This module is part of the new inventory infrastructure. The
`}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/rest/inventory/index.html"
      }}>{`Inventory Management overview`}</a>{`
describes the MSI (Multi-Source Inventory) project in more detail.`}</p>
    <h2 {...{
      "id": "installation-details"
    }}>{`Installation details`}</h2>
    <p>{`This module is installed as part of Magento Open Source. Unless a custom implementation for `}<inlineCode parentName="p">{`InventoryInStorePickupSales`}</inlineCode>{`
is provided by a 3rd-party module, the module cannot be deleted or disabled.`}</p>
    <h2 {...{
      "id": "extension-points-and-service-contracts"
    }}>{`Extension points and service contracts`}</h2>
    <p>{`All public interfaces related to this module are located in the `}<inlineCode parentName="p">{`InventoryInStorePickupSalesApi`}</inlineCode>{` module.
Use the interfaces defined in `}<inlineCode parentName="p">{`InventoryInStorePickupSalesApi`}</inlineCode>{` to extend this module.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.1.4.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      